<template>
    <!-- Layout inner -->
    <div class="layout-inner dashboard course_dashboard">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div v-if="!showPage" class="w-100">
        <spinner size="large"></spinner>
      </div>
      <template v-if="showPage">
        <div class="layout-container" v-show="!showLastActivity">
          <div class="layout-content">

            <div class="hd_bar">
              <div class="hd_ic ic-course"></div>
              <div class="hd_txt">
                <v-clamp class="title_txt" autoresize :max-lines="2" id="courseTitle">{{ course.title }}</v-clamp>

                <b-popover ref="courseTitlePopupContainer" :target="'courseTitle'" triggers="click" placement="top" class="title_popup" container="courseTitleContainer">
                  <div class="title_container">
                    {{ course.title }}
                  </div>
                  <div class="ic_container">
                    <span class="ic ic-close" v-on:click="hideCourseTitlePopup"></span>
                  </div>
                </b-popover>
                <div id="courseTitleContainer" class="title_container_popup"></div>

              </div>
            </div>

            <!-- Page content -->
            <div class="container-fluid flex-grow-1 pg_content_container">

              <div class="row">

                <div class="col-sm-12 col-xl-12 pg_sec sec_course_info">
                  <div class="row">

                    <div class="col-xl-12 sec_score" v-if="!course.hideScoreForStudent">
                      <div class="row pg_content_row major_details pt-3">

                        <div class="col-6 pg_content_col major_details_label" style="text-align: right;">
                          <span class="content_label">Current Score</span>
                        </div>

                        <div class="col-6 pg_content_col major_details_value">
                          <div class="course_score content_value" v-if="!isOpenCourse">
                            <div class="progress_block">
                              <span class="state">
                                {{ performance }}%

                                <template v-if="competencySummary.overriddenTime">
                                  <span
                                    @click="openOverrideDetailModal"
                                    class="score_modify_indicator">
                                  </span>
                                </template>
                              </span>
                            </div>
                          </div>
                          <div class="content_value" v-if="isOpenCourse">
                            {{ bbYourGrade }}%
                          </div>
                        </div>

                      </div>
                    </div>

                    <template v-if="isOpenCourse && course.lmsCourseId">
                      <div class="col-xl-12 sec_score">
                        <div class="card-text ace_sec_txt text-center" style="padding: 1.5rem 0;">Continue learning by clicking on the link below</div>
                        <div class="text-center pb-4">
                          <a :href="bblmslink()" target="_blank" class="btn">
                            <i class="iconLms_Blackboard"></i>
                            <span>goto LMS</span>
                          </a>
                        </div>
                      </div>
                    </template>

                    <div v-if="continueLearningOptions.length !== 0" class="col-12">
                      <div class="card">
                        <!--- Length === 1 -->
                        <!--- Title === COURSE_FINISHED -->
                        <template v-if="continueLearningOptions.length === 1 && continueLearningOptions[0].title === 'COURSE_FINISHED'">
                          <div class="card-body">
                            Congratulations! You have completed all competencies.
                          </div>
                        </template>

                        <!--- Length === 1 -->
                        <template v-if="continueLearningOptions.length === 1 && continueLearningOptions[0].title !== 'COURSE_FINISHED'">
                          <template v-if="!continueLearningOptions[0].startStatus">
                            <div class="card-body" tabindex="0">
                              <span class="first-row">You were working on <span class="course_entity_title" :title="continueLearningOptions[0].title">{{continueLearningOptions[0].title}}</span></span> <span class="second-row">are you ready to continue?</span>
                            </div>
                            <div class="btn_container">
                              <span class="float-left toc_row row_3 active_row"></span>
                              <b-link ref="continueLearning" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: continueLearningOptions[0].objectType, entityUuid: continueLearningOptions[0].uuid, subTopicUuid: continueLearningOptions[0].ancestor, showLastActivity: this.showLastActivity } }" class="btn continue-learning">
                                continue learning
                              </b-link>
                            </div>
                          </template>
                          <template v-if="continueLearningOptions[0].startStatus">
                            <div class="card-body"><span class="first-row">Welcome, are you ready to get started?</span></div>
                            <div class="btn_container">
                              <span class="float-left toc_row row_3 active_row"></span>
                              <b-link ref="continueLearning" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: continueLearningOptions[0].objectType, entityUuid: continueLearningOptions[0].uuid, subTopicUuid: continueLearningOptions[0].ancestor, showLastActivity: this.showLastActivity } }" class="btn continue-learning">
                                start learning
                              </b-link>
                            </div>
                          </template>
                        </template>
                        <!--- Length > 1 -->
                        <template v-if="continueLearningOptions.length > 1">
                          <div class="card-body" v-if="continueLearningOptions[1].title !== 'COURSE_LAUNCH'"><span class="first-row">You completed <span class="course_entity_title" :title="continueLearningOptions[1].title">{{continueLearningOptions[1].title}}</span></span> <span class="second-row"> <br/><br/>Next Lesson: <span class="course_entity_title" :title="continueLearningOptions[0].title">{{continueLearningOptions[0].title}}</span></span></div>
                          <div class="btn_container">
                            <span class="float-left toc_row row_3 active_row"></span>
                            <b-link ref="continueLearning" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: continueLearningOptions[0].objectType, entityUuid: continueLearningOptions[0].uuid, subTopicUuid: continueLearningOptions[0].ancestor, showLastActivity: this.showLastActivity } }" class="btn continue-learning">
                              continue learning
                            </b-link>
                          </div>
                        </template>
                      </div>
                    </div>

                  </div>
                </div>
                <template v-if="!isOpenCourse">
                  <div class="col-12" v-if="course.showProgress">
                    <div class="card pg_sec sec_progress">

                      <div class="pg_sec_hd">
                        Competency Progress
                      </div>

                      <div class="card-body">
                        <div class="progress">
                          <div class="pg_bar_txt">Ideal Pace - {{idealPaceVal}}</div>
                          <div class="progress-bar ideal_pace" :style="idealPace"></div>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="progress">
                          <div class="pg_bar_txt">Current Average Class Pace - {{classPaceVal}}</div>
                          <div class="progress-bar class_pace" :style="classPace"></div>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="progress">
                          <div class="pg_bar_txt">Your Pace - {{userPaceVal}}</div>
                          <div class="progress-bar user_pace" :style="userPace"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="isOpenCourse">
                  <div class="col-12">
                    <div class="card pg_sec sec_progress">

                      <div class="pg_sec_hd">
                        Progress
                      </div>

                      <div class="card-body" v-for="aGa in bbAggregatedGradeActivity">
                        <div class="progress">
                          <div class="pg_bar_txt">{{aGa.label}} - {{aGa.completedItems}} / {{aGa.totalItems}}</div>
                          <div class="progress-bar ideal_pace" :style="calculateProgressWidth(aGa.completedItems, aGa.totalItems)"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

              </div>
            </div>
            <!-- / Page content -->
            <!-- Footer Navbar -->
            <template v-if="!showLastActivity">
              <template v-if="continueLearningOptions.length > 0">
                <course-footer-navbar :uuid="course.uuid" :entityUuid="continueLearningOptions[0].uuid" :isCourseFinished="isCourseFinished"></course-footer-navbar>
              </template>
              <template v-else>
                <course-footer-navbar :uuid="uuid" :isCourseFinished="isCourseFinished"></course-footer-navbar>
              </template>
            </template>
            <!-- / Footer Navbar -->
          </div>
        </div>
      </template>
      <!-- Override Modal -->
        <div class="modal_popup_container course_unlock_modal modify_score_modal edited_score_modal">
          <b-modal ref="learnerCourseOverrideModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
            <div slot="modal-header" class="header-section">
              <div class="head_txt" style="margin-top: 1px;">Edited Overall Score and Progress</div>
              <div class="btn_container">
                <button type="button" class="btn_close" @click="closeLearnerCourseOverrideModal" data-dismiss="modal" aria-label="Close">
                  <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="row txt_row">
              <div class="col-6">
                Course:
              </div>
              <div class="col-6 fld_val">
                <div v-html="course.title"></div>
              </div>
            </div>

              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Actual Overall Score:
                </div>
                <div class="col-6 fld_input" v-if="competencySummary">
                  <span v-if="competencySummary.overriddenTime" class="exp_info">{{competencySummary.prePerformance?competencySummary.prePerformance:0}}%</span>
                  <span v-else class="exp_info">{{competencySummary.performance}}%</span>
                </div>
              </div>
              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Edited Overall Score:
                </div>
                <div class="col-6 fld_input">
                  <span class="exp_info">{{competencySummary.performance}}%</span>
                </div>
              </div>

              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Actual Overall Progress:
                </div>
                <div class="col-6 fld_input progress-row" v-if="competencySummary">
                <div class="progress-bar-label">
                  {{competencySummary.preChildrenCompleteCount}} of {{competencySummary.childrenCount}}
                </div>
                <b-progress :max="competencySummary.childrenCount">
                  <b-progress-bar :value="competencySummary.preChildrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                </b-progress>
                </div>
              </div>
              <div class="row txt_row mt-3" v-if="competencySummary && competencySummary.overriddenTime>0">
                <div class="col-6 ">
                  Edited Overall Progress:
                </div>
                <div class="col-6 fld_input progress-row">
                <div class="progress-bar-label">
                  {{competencySummary.childrenCompleteCount}} of {{competencySummary.childrenCount}}
                </div>
                <b-progress :max="competencySummary.childrenCount">
                  <b-progress-bar :value="competencySummary.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                </b-progress>
                </div>
              </div>
              <div class="row txt_row mt-3">
                <div class="col-12 ">
                  Edited By {{competencySummary.overriddenBy}} at  {{millisToDate(competencySummary.overriddenTime)}}
                </div>
              </div>

            <div class="row mt-4">
              <div class="col-12 btn_container" style="text-align: right;">
                <b-button @click="closeLearnerCourseOverrideModal">
                  {{ $tf('ok') }}
                </b-button>
              </div>
            </div>
          </b-modal>
        </div>
<!-- Override Modal -->

    </div>
    <!-- Layout inner -->
</template>

<script>
import { DateTime } from 'luxon'
import { mapActions, mapState } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import SecondaryNavbar from '../../misc/components/./SecondaryNavbar'
import CourseFooterNavbar from '../../misc/components/./CourseFooterNavbar'
import VClamp from 'vue-clamp'

export default {
  name: 'courseDashboard',
  props: ['uuid', 'showLastActivity'],
  components: {
    Navbar,
    SecondaryNavbar,
    CourseFooterNavbar,
    VClamp
  },
  data: () => {
    return {
      course: {},
      competencySummary: {},
      continueLearningOptions: [],
      idealPaceVal: '',
      classPaceVal: '',
      userPaceVal: '',
      pace: {},
      bbCourseAccess: {},
      bbContentAccess: {},
      bbGradeActivity: {},
      bbAggregatedGradeActivity: {},
      bbAnnouncements: {},
      showPage: false
    }
  },

  mounted () {
    this.loadCourseInfo()
  },

  updated () {
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.showLastActivity && this.$refs.continueLearning) {
          this.$refs.continueLearning.$el.click()
        }
      })
    })
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadContinueLearningLast',
      'loadClassSummaryWithPeer',
      'loadCompetencyProgress',
      'loadUserObj',
      'loadBlackboardCourseAccess',
      'loadBlackboardContentAccess',
      'loadBlackboardAnnouncements',
      'loadBlackboardGradeActivity',
      'loadBlackboardAggregatedGradeActivity'
    ]),
    async loadCourseInfo () {
      this.course = await this.loadCourseDetail(this.uuid)
      if (this.isOpenCourse && !this.course.lmsCourseId) {
        return this.$router.push({ name: 'courseDetail', params: { uuid: this.uuid } })
      }
      if (this.isOpenCourse && this.course.lmsCourseId) {
        this.bbCourseAccess = await this.loadBlackboardCourseAccess(this.course.lmsCourseId)
        this.bbContentAccess = await this.loadBlackboardContentAccess(this.course.lmsCourseId)
        this.bbAnnouncements = await this.loadBlackboardAnnouncements(this.course.lmsCourseId)
        this.bbGradeActivity = await this.loadBlackboardGradeActivity(this.course.lmsCourseId)
        this.bbAggregatedGradeActivity = await this.loadBlackboardAggregatedGradeActivity(this.course.lmsCourseId)
      }
      this.continueLearningOptions = await this.loadContinueLearningLast(this.uuid)
      this.pace = await this.loadClassSummaryWithPeer(this.uuid)
      this.competencySummary = await this.loadCompetencyProgress(this.uuid)
      await this.loadUserObj()
      this.showPage = true
    },
    hideCourseTitlePopup () {
      this.$refs.courseTitlePopupContainer.$emit('close')
    },
    openOverrideDetailModal () {
      this.$refs.learnerCourseOverrideModal.show()
    },
    closeLearnerCourseOverrideModal () {
      this.$refs.learnerCourseOverrideModal.hide()
    },
    millisToDate (millis) {
      return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
    },
    bblmslink () {
      if (this.course && this.course.lmsCourseId) {
        return 'https://nu.blackboard.com/webapps/blackboard/execute/launcher?type=Course&id=_' + this.course.lmsCourseId + '_1&url='
      }
    },
    calculateProgressWidth (completed, total) {
      if (total > 0) {
        let iP = (completed / total) * 100
        return 'width: ' + iP + '%;'
      }
      return 'width: 0%;'
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj
    }),

    isOpenCourse () {
      if (this.course && (this.course.courseType === 'OPEN' || (this.course.courseType && this.course.courseType.includes('EXTERNAL_')))) {
        return true
      } else {
        return false
      }
    },

    bbCourseAccessActivity () {
      var activities = []
      if (this.bbCourseAccess) {
        activities.push({name: 'Max', count: this.bbCourseAccess.Max, color: '#005391'})
        activities.push({name: 'Min', count: this.bbCourseAccess.Min, color: '#005391'})
        activities.push({name: 'You', count: this.bbCourseAccess.You, color: '#f3c744'})
        activities.push({name: 'Avg', count: this.bbCourseAccess.Average, color: '#005391'})
        return activities
      } else {
        activities.push({name: 'Max', count: 0, color: '#005391'})
        activities.push({name: 'Min', count: 0, color: '#005391'})
        activities.push({name: 'You', count: 0, color: '#f3c744'})
        activities.push({name: 'Avg', count: 0, color: '#005391'})
        return activities
      }
    },

    bbContentAccessActivity () {
      var activities = []
      if (this.bbContentAccess) {
        activities.push({name: 'Max', count: this.bbContentAccess.Max, color: '#005391'})
        activities.push({name: 'Min', count: this.bbContentAccess.Min, color: '#005391'})
        activities.push({name: 'You', count: this.bbContentAccess.You, color: '#f3c744'})
        activities.push({name: 'Avg', count: this.bbContentAccess.Average, color: '#005391'})
        return activities
      } else {
        activities.push({name: 'Max', count: 0, color: '#005391'})
        activities.push({name: 'Min', count: 0, color: '#005391'})
        activities.push({name: 'You', count: 0, color: '#f3c744'})
        activities.push({name: 'Avg', count: 0, color: '#005391'})
        return activities
      }
    },

    bbGradeActivityChart () {
      var activities = []
      if (this.bbGradeActivity) {
        activities.push({name: 'Max', count: this.bbGradeActivity.Max, color: '#005391'})
        activities.push({name: 'Min', count: this.bbGradeActivity.Min, color: '#005391'})
        activities.push({name: 'You', count: this.bbGradeActivity.You, color: '#f3c744'})
        activities.push({name: 'Avg', count: this.bbGradeActivity.Average, color: '#005391'})
        return activities
      } else {
        activities.push({name: 'Max', count: 0, color: '#005391'})
        activities.push({name: 'Min', count: 0, color: '#005391'})
        activities.push({name: 'You', count: 0, color: '#f3c744'})
        activities.push({name: 'Avg', count: 0, color: '#005391'})
        return activities
      }
    },

    bbYourGrade () {
      if (this.bbGradeActivity && this.bbGradeActivity.You) {
        let performance = this.bbGradeActivity.You
        return performance.toFixed(2)
      } else {
        return '0.00'
      }
    },

    performance () {
      const performance = this.competencySummary.performance
      return (performance) ? performance.toFixed(2) : '0.00'
    },
    idealPace () {
      if (this.pace && this.pace.totalPace) {
        this.idealPaceVal = ((this.pace.idealPace) ? this.pace.idealPace.toFixed(2) : '0.00') + '/' + this.pace.totalPace
        let iP = (this.pace.idealPace / this.pace.totalPace) * 100
        return 'width: ' + iP + '%;'
      }
      return 'width: 0%;'
    },
    classPace () {
      if (this.pace && this.pace.totalPace) {
        this.classPaceVal = ((this.pace.classPace) ? this.pace.classPace.toFixed(2) : '0.00') + '/' + this.pace.totalPace
        let cP = (this.pace.classPace / this.pace.totalPace) * 100
        return 'width: ' + cP + '%;'
      }
      return 'width: 0%;'
    },
    userPace () {
      if (this.pace && this.pace.totalPace) {
        this.userPaceVal = ((this.pace.userPace) ? this.pace.userPace.toFixed(2) : '0.00') + '/' + this.pace.totalPace
        let uP = (this.pace.userPace / this.pace.totalPace) * 100
        return 'width: ' + uP + '%;'
      }
      return 'width: 0%;'
    },
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    major () {
      if (this.userObj) {
        return this.userObj.major1Title
      } else {
        return ''
      }
    },
    majorGPA () {
      if (this.userObj) {
        return this.userObj.majorGpa
      } else {
        return '0.0'
      }
    },
    overallGPA () {
      if (this.userObj) {
        return this.userObj.overallGpa
      } else {
        return '0.0'
      }
    },
    isCourseFinished () {
      let isFinished = true
      if (this.continueLearningOptions.length > 0 && (this.continueLearningOptions[0].title !== 'COURSE_FINISHED')) {
        isFinished = false
      }
      return isFinished
    }
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/CourseDashboard.vue